import {
  BarChart3,
  Boxes,
  Braces,
  BookOpen,
  Bell,
  Bot,
  Clapperboard,
  Coins,
  Cpu,
  FileCode,
  FileText,
  Gauge,
  GalleryThumbnails,
  History,
  Languages,
  LayoutDashboard,
  MessageSquareWarning,
  Package,
  Power,
  Receipt,
  Settings,
  Share2,
  Shield,
  Store,
  TicketPercent,
  Terminal,
  UserCircle,
  Users,
  Workflow,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  path: string;
  Icon: LucideIcon;
}

export const mainNavItems: NavItem[] = [
  { id: 'dashboard', label: 'Dashboard', path: '/dashboard', Icon: LayoutDashboard },
  { id: 'users', label: 'User Management', path: '/users', Icon: Users },
  { id: 'feedback', label: 'Feedback Management', path: '/feedback', Icon: MessageSquareWarning },
  { id: 'admin-mail', label: 'Notifications', path: '/admin-mail', Icon: Bell },
  { id: 'docs', label: 'Docs', path: '/docs', Icon: BookOpen },
  { id: 'admin-agent', label: 'Agent Management', path: '/admin-agent', Icon: Bot },
  { id: 'packages', label: 'Package Management', path: '/packages', Icon: Package },
  {
    id: 'package-capabilities',
    label: 'Package Capabilities',
    path: '/package-capabilities',
    Icon: Cpu,
  },
  { id: 'advance-tokens', label: 'Advance Credits', path: '/advance-tokens', Icon: Coins },
  { id: 'payments', label: 'Payments', path: '/payments', Icon: Receipt },
  { id: 'referrals', label: 'Referrals', path: '/referrals', Icon: Share2 },
  { id: 'campaigns', label: 'Campaigns', path: '/campaigns', Icon: TicketPercent },
  { id: 'generate-video', label: 'Generate Video', path: '/generate-video', Icon: Clapperboard },
  { id: 'feature-tracking', label: 'Feature Tracking', path: '/feature-tracking', Icon: BarChart3 },
];

export const systemNavItems: NavItem[] = [
  {
    id: 'capabilities',
    label: 'Capability Management',
    path: '/capabilities',
    Icon: Cpu,
  },
  {
    id: 'llm-catalog',
    label: 'LLM Catalog',
    path: '/llm-catalog',
    Icon: Boxes,
  },
  {
    id: 'input-formats',
    label: 'Input Formats',
    path: '/input-formats',
    Icon: Braces,
  },
  {
    id: 'internal-ai-tasks',
    label: 'Internal AI Tasks',
    path: '/internal-ai-tasks',
    Icon: Workflow,
  },
  {
    id: 'system-characteristics',
    label: 'System Characteristics',
    path: '/system-characteristics',
    Icon: FileCode,
  },
  {
    id: 'tool-calls',
    label: 'Tool Management',
    path: '/tool-calls',
    Icon: Wrench,
  },
  {
    id: 'marketplace',
    label: 'Marketplace',
    path: '/marketplace',
    Icon: Store,
  },
  {
    id: 'system-prompts',
    label: 'System Prompts',
    path: '/system-prompts',
    Icon: FileText,
  },
  { id: 'billing-report', label: 'Cost Report', path: '/billing-report', Icon: BarChart3 },
];

export const codeAgentMonitorNavItems: NavItem[] = [
  {
    id: 'ca-sessions',
    label: 'Sessions',
    path: '/code-agent/sessions',
    Icon: Terminal,
  },
  {
    id: 'ca-tools',
    label: 'Tool Diagnostics',
    path: '/code-agent/tools',
    Icon: Wrench,
  },
];

export const codeAgentConfigNavItems: NavItem[] = [
  {
    id: 'ca-runtime',
    label: 'Runtime Settings',
    path: '/code-agent/runtime',
    Icon: Settings,
  },
  {
    id: 'ca-kill',
    label: 'Policy & Kill Switches',
    path: '/code-agent/kill-switches',
    Icon: Power,
  },
];

export const settingsNavItems: NavItem[] = [
  {
    id: 'global-settings',
    label: 'Global Settings',
    path: '/global-settings',
    Icon: Settings,
  },
  {
    id: 'account-settings',
    label: 'Account Settings',
    path: '/account-settings',
    Icon: UserCircle,
  },
  {
    id: 'agent-avatars',
    label: 'Agent Avatars',
    path: '/agent-avatars',
    Icon: GalleryThumbnails,
  },
  {
    id: 'anonymous-limits',
    label: 'Anonymous Limits',
    path: '/anonymous-limits',
    Icon: Gauge,
  },
  {
    id: 'language-settings',
    label: 'Language Settings',
    path: '/language-settings',
    Icon: Languages,
  },
];

/** Every page that is a log/audit trail, grouped so they are easy to find. */
export const logsNavItems: NavItem[] = [
  {
    id: 'assistant-history',
    label: 'Assistant History',
    path: '/assistant-history',
    Icon: History,
  },
  {
    id: 'ai-logs',
    label: 'AI Usage Logs',
    path: '/ai-logs',
    Icon: BarChart3,
  },
  {
    id: 'ca-audit',
    label: 'Code Agent Audit Logs',
    path: '/code-agent/audit',
    Icon: Shield,
  },
];
